import { jsx as o } from "react/jsx-runtime";
import { LocalizationProvider as l } from "@bynder/localization";
import { DesignSystemProvider as t } from "@bynder/design-system";
import { CropperModal as a } from "./index7.js";
import { getLocale as r, fetchStorybookFallback as p } from "./index8.js";
const n = (e) => /* @__PURE__ */ o(
  l,
  {
    locale: r(),
    fetchFallback: p,
    project: "react-image-cropper-lib",
    children: /* @__PURE__ */ o(t, { locale: r(), children: /* @__PURE__ */ o(a, { ...e }) })
  }
);
export {
  n as CropperModal
};
